import { createClient } from '@supabase/supabase-js';

// 🔧 HIER deine Supabase-Daten eintragen (siehe ANLEITUNG.md)
const SUPABASE_URL = 'https://oxzuugwjokscqnfwcnxf.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im94enV1Z3dqb2tzY3FuZndjbnhmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQzNzI2ODEsImV4cCI6MjA4OTk0ODY4MX0.QEJ4Vzd1-JqCTVZowQtkrl7Nx0iVcgzondDv-jIPLcY';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
